import React from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const Dictaphone = () => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  if (!browserSupportsSpeechRecognition) {
    return <span className="text-red-500">Tarayıcınız sesli komutları desteklemiyor.</span>;
  }

  const startListening = () => {
    SpeechRecognition.startListening({
      language: 'tr-TR',
      continuous: true, // Mikrofonu sürekli açık tutuyoruz
      interimResults: true // Anlık sonuçları almak için
    });
  };

  return (
    <div className="flex flex-col items-center justify-center p-6 bg-gray-100 rounded-lg shadow-lg max-w-sm mx-auto">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Sesli Komut</h2>
      <p className="text-lg text-gray-700 mb-2">Mikrofon: {listening ? 'Açık' : 'Kapalı'}</p>
      
      <div className="flex space-x-4 mb-4">
        <button
          onClick={startListening}
          className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-300"
        >
          Başlat
        </button>
        <button
          onClick={SpeechRecognition.stopListening}
          className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-300"
        >
          Durdur
        </button>
        <button
          onClick={resetTranscript}
          className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition duration-300"
        >
          Sıfırla
        </button>
      </div>

      <div className="w-full mt-4">
        <p className="text-lg font-semibold text-gray-800">Sonuç:</p>
        <p className="text-lg text-gray-600 mt-2">{transcript || 'Henüz bir şey söylemediniz.'}</p>
      </div>
    </div>
  );
};

export default Dictaphone;
